import React, { useState } from "react";

const LessonPlanCalculator = () => {
  const [topics, setTopics] = useState("");
  const [timePerTopic, setTimePerTopic] = useState("");
  const [totalTime, setTotalTime] = useState(null);

  const calculateTime = () => {
    setTotalTime(topics * timePerTopic);
  };

  return (
    <div className="p-6 bg-gray-100 rounded-lg shadow-lg mx-auto mt-5">
      <h2 className="text-xl font-bold text-center text-blue-600">Lesson Plan Time Calculator</h2>
      <input type="number" placeholder="No. of Topics" className="border p-2 w-full mt-3" onChange={(e) => setTopics(e.target.value)} />
      <input type="number" placeholder="Time Per Topic (mins)" className="border p-2 w-full mt-3" onChange={(e) => setTimePerTopic(e.target.value)} />
      <button className="mt-4 bg-blue-500 text-white py-2 px-4 rounded w-full" onClick={calculateTime}>Calculate Time</button>
      {totalTime && <div className="mt-3 text-center text-lg">Total Time: <span className="font-bold text-green-600">{totalTime} mins</span></div>}
    </div>
  );
};

export default LessonPlanCalculator;
